import { captureException } from '@sentry/react'
import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpSubmitService,
	httpSubmitService
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { Service } from '@/features/service-vetting/types.ts'
import { errorHandler, parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useSubmitService = (
	urlParams: HttpSubmitService['urlParams'],
	options?: UseMutationOptions<Service, unknown, HttpSubmitService['payload']>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			parseAxiosPromise({
				axiosPromise: httpSubmitService({
					urlParams,
					payload,
					params: {
						response_type: 'extended'
					}
				}),
				responseShape: Service,
				onZodError: captureException
			}),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_VETTING]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
